import { elo as theme } from '../../themes';
import { variants } from '../../util';
var getColors = function getColors(variant) {
  switch (variant) {
    case variants.POSITIVE:
      return {
        background: theme.colors.mint10,
        borderColor: theme.colors.mint40,
        iconColor: theme.colors.mint30
      };
    case variants.NEGATIVE:
      return {
        background: theme.colors.red10,
        borderColor: theme.colors.red40,
        iconColor: theme.colors.red30
      };
    case variants.INFORMATIVE:
      return {
        background: theme.colors.cyan10,
        borderColor: theme.colors.cyan40,
        iconColor: theme.colors.cyan30
      };
    default:
      return {
        background: theme.colors.honey10,
        borderColor: theme.colors.honey40,
        iconColor: theme.colors.honey30
      };
  }
};
export default getColors;